import useMountEffect from '@zenbusiness/application-commons-hooks/useMountEffect';
import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import { LoadingZone } from '@zenbusiness/application-commons-loading';
import Stack from '@zenbusiness/zui/Stack';

import PageHeader from '#client/components/PageHeader';
import Trustpilot from '#client/components/Trustpilot';
import useCheckoutStarted from '#client/hooks/clickstream/useCheckoutStarted';
import TwoColumnLayout from '#client/layouts/TwoColumnLayout';
import { CardRoot as Card } from '#client/pages/Checkout/Checkout.style';
import Faqs from '#client/pages/Checkout/components/Faqs';
import ListCallout from '#client/pages/Checkout/components/ListCallout';
import TaxesCallout from '#client/pages/Checkout/components/TaxesCallout';

import CheckoutForm from './components/CheckoutForm';
import { CheckoutProvider } from './hooks/useCheckout';
import { useCheckoutSections } from './hooks/useCheckoutSections';
import { PaymentProvider } from './hooks/usePaymentContext';

const MESSAGE_IDS = {
  subtitle: 'shopping.page.checkoutSmartLlc.subtitle',
  title: 'shopping.page.checkoutSmartLlc.title'
};

function CheckoutSmartLlcPage() {
  const trackCheckoutStarted = useCheckoutStarted();
  const sections = useCheckoutSections();

  useMountEffect(() => {
    trackCheckoutStarted({ totalSteps: sections.length });
  });

  return (
    <LoadingZone bubble loadId="Checkout" timeout={10000}>
      <TwoColumnLayout>
        <TwoColumnLayout.SmallColumn>
          <PageHeader
            hideBack
            subtitle={<FormattedMessage id={MESSAGE_IDS.subtitle} />}
            title={<FormattedMessage id={MESSAGE_IDS.title} />}
          />
          <PaymentProvider>
            <CheckoutProvider>
              <CheckoutForm sections={sections} />
            </CheckoutProvider>
          </PaymentProvider>
        </TwoColumnLayout.SmallColumn>

        <TwoColumnLayout.LargeColumn>
          <Stack spacing={2} top={64}>
            <Stack display={{ xs: 'none', md: 'flex' }} spacing={2}>
              <Card size="lg">
                <ListCallout />
                <TaxesCallout />
              </Card>
              <Trustpilot />
            </Stack>
            <Faqs messageKey="shopping.page.checkout" />
          </Stack>
        </TwoColumnLayout.LargeColumn>
      </TwoColumnLayout>
    </LoadingZone>
  );
}

export default CheckoutSmartLlcPage;
